import { Subtitle2Stronger, tokens } from "@fluentui/react-components";
import DescriptionOutlineIcon from "~icons/material-symbols/description-outline";
import { memo } from "react";
import { EllipsisTooltip } from "../../../components/EllipsisTooltip/EllipsisTooltip";
import { IDocument } from "../../../interfaces";
import { useDocHeaderStyles } from "../styles/DocHeader.styles";
type DocHeaderProps = {
  doc: IDocument;
};

export const DocHeader = memo(({ doc }: DocHeaderProps) => {
  const styles = useDocHeaderStyles();
  return (
    <div className={styles.docHeader}>
      <DescriptionOutlineIcon color={tokens.colorBrandBackground} />
      <Subtitle2Stronger wrap={false} className={styles.docTitle}>
        <EllipsisTooltip content={doc.doc_file_name}>
          <span>{doc.doc_file_name}</span>
        </EllipsisTooltip>
      </Subtitle2Stronger>
    </div>
  );
});
